@if (cpr(); as c) {
<!-- Order Meta -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Order Number</strong>
          <p>{{ c.cprNumber }}</p>
        </td>
        <td>
          <strong>Date</strong>
          <p>{{ c.date ? (c.date | date: 'mediumDate') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Location</strong>
          <p>{{ fullDetail()?.locationName || c.locationName || '-' }}</p>
          @if (fullDetail(); as d) {
          @if (d.locationStreet) {
          <p class="detail-subtext">{{ d.locationStreet }}</p>
          }
          @if (d.locationCity) {
          <p class="detail-subtext">{{ d.locationCity }}, {{ d.locationState }} {{ d.locationZip }}</p>
          }
          }
        </td>
        <td>
          <strong>Transportation Method</strong>
          <p>{{ fullDetail()?.shipvia || c.shipvia || '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Transport -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Reference Number</strong>
          <p>{{ c.customerReferenceNumber || '-' }}</p>
        </td>
        <td>
          @if (fullDetail()?.manualBOL) {
          <strong>BOL</strong>
          <p>{{ fullDetail()!.manualBOL }}</p>
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Special Instructions -->
@if (fullDetail()?.comments) {
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td colspan="2">
          <strong>Special Instructions</strong>
          <p>{{ fullDetail()!.comments }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
}

<!-- Status -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Status</strong>
          <p>
            <span class="status-badge">{{ statusLabel() }}</span>
          </p>
        </td>
        <td>
          <strong>Created On</strong>
          <p>{{ c.createdOn ? (c.createdOn | date: 'mediumDate') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Line Items -->
<div class="detail-section">
  <h3 class="detail-section__heading">Line Items</h3>
  @if (detailLoading()) {
  <p class="detail-loading">Loading line items...</p>
  } @else if (fullDetail()?.lineItems?.length) {
  <table class="detail-table line-items-table">
    <thead>
      <tr>
        <td>Product</td>
        <td>Quantity</td>
      </tr>
    </thead>
    <tbody>
      @for (item of fullDetail()!.lineItems; track $index) {
      <tr>
        <td>
          <strong class="line-item-name">{{ item.productName }}</strong>
        </td>
        <td>{{ item.quantity }} / EACH</td>
      </tr>
      }
    </tbody>
  </table>
  } @else if (fullDetail()) {
  <p class="detail-empty">No line items.</p>
  }
</div>
}